import Home from './container/HomeContainer';

export default Home;
